import React from 'react';
import { useCurrentPage } from '../../hooks/useCurrentPage';
import { MarqueeBanner } from './MarqueeBanner';

/**
 * Page-specific scrolling banner (Admin → Pages → Show Marquee).
 */
const PageMarquee: React.FC = () => {
  const currentPage = useCurrentPage();

  const showMarquee = currentPage?.show_marquee === true;
  const text = currentPage?.marquee_text?.trim() ?? '';

  if (!showMarquee || !text) {
    return null;
  }

  return <MarqueeBanner text={text} variant="page" />;
};

export default PageMarquee;
